import React, { useState, useEffect } from 'react';
import { useTheme } from './ThemeContext';
import './theme.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header style={{ ...styles.header, ...(isScrolled ? styles.headerScrolled : {}) }}>
      <div style={styles.container}>
        <div style={styles.logo}>
          <a href="https://muqueetmc.com" style={styles.logoLink}>
            Muqueet Mohsen Chowdhury
          </a>
        </div>
        <button 
          style={styles.menuButton}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span style={styles.menuIcon}>☰</span>
        </button>
        <nav style={{ ...styles.nav, ...(isMobileMenuOpen ? styles.navOpen : {}) }}>
          <a
            href="https://github.com/mmc03-ucb?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/muqueet-mohsen-chowdhury-6a83a9242"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            LinkedIn
          </a>
          <a
            href="https://devpost.com/mmc324?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Devpost
          </a>
          <button
            style={styles.themeToggle}
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {isDarkMode ? '☀️' : '🌙'}
            <span style={styles.themeLabel}>{isDarkMode ? 'Light' : 'Dark'}</span>
          </button>
        </nav>
      </div>
    </header>
  );
};

const styles = {
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'var(--header-bg)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 1px 3px var(--header-shadow)',
    zIndex: 1000,
    transition: 'all 0.3s ease-in-out',
  },
  headerScrolled: {
    backgroundColor: 'var(--header-bg)',
    boxShadow: '0 2px 10px var(--header-shadow)',
  },
  container: {
    maxWidth: '1200px',
    padding: '1rem 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    fontSize: '1.5rem',
    fontWeight: '700',
    '@media (max-width: 768px)': {
      fontSize: '1.25rem',
    },
  },
  logoLink: {
    color: 'var(--gray-900)',
    textDecoration: 'none',
    transition: 'color 0.2s ease-in-out',
  },
  menuButton: {
    display: 'none',
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    padding: '0.5rem',
    color: 'var(--text-color)',
    '@media (max-width: 768px)': {
      display: 'block',
    },
  },
  menuIcon: {
    color: 'var(--gray-900)',
  },
  nav: {
    display: 'flex',
    gap: '2rem',
    '@media (max-width: 768px)': {
      display: 'none',
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: 'var(--background-color)',
      padding: '1rem',
      flexDirection: 'column',
      gap: '1rem',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    },
  },
  navOpen: {
    '@media (max-width: 768px)': {
      display: 'flex',
    },
  },
  link: {
    color: 'var(--gray-700)',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: '500',
    padding: '0.5rem 0',
    position: 'relative',
    transition: 'color 0.2s ease-in-out',
    ':hover': {
      color: 'var(--primary-color)',
    },
    '@media (max-width: 768px)': {
      padding: '0.75rem',
      textAlign: 'center',
    },
  },
  themeToggle: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    background: 'var(--card-border)',
    border: 'none',
    borderRadius: '8px',
    padding: '0.5rem 1rem',
    color: 'var(--text-color)',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'all 0.2s ease-in-out',
    ':hover': {
      background: 'var(--header-shadow)',
    },
    '@media (max-width: 768px)': {
      width: '100%',
      justifyContent: 'center',
    },
  },
  themeLabel: {
    fontSize: '0.875rem',
    fontWeight: '500',
  },
};

export default Header;
